<ion-card>
  <div class="image-container">
    <img [src]="feed.image_urls[0] || './assets/imgs/feed_marriage.png'"
      *ngIf="feed.image_urls && feed.image_urls.length > 0 && feed.image_urls[0]" class="card-image"
      (click)="feedService.openDetails(feed.id)" (error)="onImageError($event)">
    <img src="./assets/imgs/feed_marriage.png"
      *ngIf="!feed.image_urls || feed.image_urls.length == 0 || !feed.image_urls[0]" (click)="feedService.openDetails(feed.id)"
      class="card-image">
    <!-- <div class="imageCounter" *ngIf="feed.image_urls.length > 1">
      <ion-icon name="images-outline"></ion-icon>
      {{ feed.image_urls.length }}
    </div> -->
    <div class="imageCounter" *ngIf="!details">
      <ion-button size="small" shape="round" color="light" (click)="showEmojiBox = !showEmojiBox">
        <ion-icon style="padding-right: 5px;" [name]="isLiked ? 'heart' : 'heart-outline'"
          [style.color]="isLiked ? '#ff002d' : '#ff002d'"></ion-icon>
        Like
      </ion-button>
    </div>

    <div class="gradient-overlay"></div>
    <div class="overlay-text">
      <div *ngIf="feed.reactionKeys" class="scrollable" style="width: 80vw;">
        <span *ngFor="let key of feed.reactionKeys">{{feed.reaction_count[key]}} {{key}}</span>
      </div>
      <div class="imageName" (click)="feedService.openDetails(feed.id)" *ngIf="feed.creator">{{ feed.header }}</div>
      <div *ngIf="feed.json_details && !details">
        <div class="imageData">{{feed.json_details.profession}}, {{feed.json_details.studies}},
          {{feed.json_details.current_location}} </div>
        <div class="imageData">{{feed.event_date|age}} , {{feed.json_details.height}}</div>

        <div class="imageData">Looking for: {{feed.json_details.partner_preferences}}</div>

      </div>
      <a style="color:white" *ngIf="(feed.json_details.contact_number || feed.json_details.contact) && details"
        [href]="'tel:'+feed.json_details.contact_number">
        <ion-row>
          <ion-col class="padding2 textCenter" size="2">
            <ion-icon color="success" name="call"></ion-icon>
          </ion-col>
          <ion-col class="padding2" size="10">
            <div style="width: 100%; overflow-x: auto; white-space: nowrap;">
              <b>{{feed.json_details.contact}}</b> {{feed.json_details.contact_number}}
            </div>
          </ion-col>
        </ion-row>
      </a>
    </div>
  </div>

  <div *ngIf="details && feed.json_details">
    <h4>Personal Details</h4>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Height</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.height}}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Weight</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.weight}}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Color</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.color}}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Birth Place</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.birth_place}}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Gender</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.gender}}</ion-col>
    </ion-row>

    <h4>Religious & Cultural Background</h4>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Family Details</ion-col>
      <ion-col size="8" class="borderMedium padding4">
        <div [innerHTML]="feed.json_details.family_members | linebreaks"></div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Family Location</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.location}}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Community</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.community}}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Gotra</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.gotra}}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Nakshatra</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.nakshatra}}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Raashi</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.raashi}}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Manglik</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.mangalik}}</ion-col>
    </ion-row>

    <h4>Educational & Professional Details</h4>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Studies</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.studies}}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Profession</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.profession}}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Designation</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.designation}}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Organization</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.organization}}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Current Location</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.current_location}}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Salary</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.salary}}</ion-col>
    </ion-row>

    <h4>LifeStyle</h4>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Likes</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.likes}}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Hobbies</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.hobbies}}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Diet</ion-col>
      <ion-col size="8" class="borderMedium padding4">{{feed.json_details.diet}}</ion-col>
    </ion-row>

    <h4>Preferences</h4>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Partner Preferences</ion-col>
      <ion-col size="8" class="borderMedium padding4">
        <div [innerHTML]="feed.json_details.partner_preferences | linebreaks"></div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="borderMedium padding4">Location Preferences</ion-col>
      <ion-col size="8" class="borderMedium padding4">
        <div [innerHTML]="feed.json_details.location_preferences | linebreaks"></div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="1.5">
        <span *ngIf="feed.creator">
          <img width="30px" height="30px" [src]="feed.creator.url" *ngIf="feed.creator && feed.creator.url"
            class="circular">
          <ion-icon name="person-circle-outline" *ngIf="!feed.creator.url" class="font3" color="light"></ion-icon>
        </span>
      </ion-col>
      <ion-col [size]="details ? '9.5' : '7.5'">
        <div *ngIf="feed.creator">{{feed.creator.name}}</div>
        <div class="font0_8">{{feed.created_at | fancyDate}}</div>

      </ion-col>
      <ion-col size="1">
        <ion-icon name="logo-whatsapp" (click)="feedService.share(feed)"></ion-icon>
      </ion-col>
      <ion-col size="1" *ngIf="!details">
        <ion-icon (click)="showEmojiBox = !showEmojiBox" name="heart-outline"></ion-icon>
      </ion-col>
      <ion-col size="1" *ngIf="!details">
        <ion-icon (click)="feedService.openDetails(feed.id)" name="chatbubble-outline"></ion-icon>
      </ion-col>
    </ion-row>
  </div>
  <ion-row *ngIf="showEmojiBox" class="emojiBox">
    <ion-col size="2" *ngFor="let emoji of reactionService.emojiList" (click)="clickEmoji(emoji)" class="font1_5">
      {{emoji}}
    </ion-col>
  </ion-row>
</ion-card>